import { textStyles } from '../../utils/styles';

export default function Logo() {
    return (
        <div className="flex items-center w-[100%]">
            <h1 className={textStyles.logo}>Dt</h1>

        </div>
    )
}
